<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Part</h1>
    </div>
    <div class="ui floating negative message" v-if="error">
      <i class="close icon"></i>
      <div class="header">We're sorry but an error occurred</div>
      <p>{{ error }}</p>
    </div>
    <form class="ui form segment" @submit.prevent="partUpdate">
      <div class="ui grid stackeable">
        <div class="row">
          <div class="eight wide column">
            <label>Machine</label>
            <div
              class="ui fluid search selection dropdown"
              :class="[{ disabled: disabled }]"
              id="MachineSelect"
            >
              <input
                type="hidden"
                name="machine"
                v-model="machineId"
                id="Machine"
                @change="onMachineChange"
              />
              <div class="default text">Select Machine</div>
              <i class="dropdown icon"></i>
              <i class="remove icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="machine in machines"
                  :key="machine.value"
                  v-bind:data-value="machine.value"
                >
                  {{ machine.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="machineId">
          <div class="eight wide column">
            <label>Assembly</label>
            <div
              class="ui fluid search selection dropdown"
              :class="[{ disabled: disabled }]"
              id="AssemblySelect"
            >
              <input
                type="hidden"
                name="assembly"
                v-model="assemblyId"
                id="Assembly"
                @change="onAssemblyChange"
              />
              <div class="default text">Select Assembly</div>
              <i class="dropdown icon"></i>
              <i class="remove icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in assemblies"
                  :key="assembly.value"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="assemblyId">
          <div class="eight wide column">
            <label>Sub-Assembly</label>
            <div
              class="ui fluid search selection dropdown"
              id="SubAssemblySelect"
            >
              <input
                type="hidden"
                name="subassemly"
                v-model="subAssemblyId"
                id="Subassembly"
                @change="onSubAssemblyChange"
              />
              <div class="default text">Select Sub-Assembly</div>
              <i class="dropdown icon"></i>
              <i class="remove icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in subAssemblies"
                  :key="assembly.value"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="subAssemblyId">
          <div class="eight wide column">
            <label>Code</label>
            <div
              class="ui fluid search selection dropdown"
              id="CodeSelect"
            >
              <input
                type="hidden"
                name="Code"
                v-model="code"
                id="Code"
                @change="onCodeChange"
              />
              <div class="default text">Select Code</div>
              <i class="dropdown icon"></i>
              <i class="remove icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="code in codes"
                  :key="code.value"
                  v-bind:data-value="code.value"
                  v-bind:data-price="code.price"
                >
                  {{ code.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Item</label>
            <input type="text" name="Item" placeholder="Item" v-model="item" />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Description</label>
            <input
              type="text"
              name="Description"
              placeholder="Description"
              v-model="description"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Quantity per Machine</label>
            <input
              type="text"
              name="QtyPerMachine"
              placeholder="Quantity per Machine"
              v-model="quantityPerMachine"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Price (Set in Visual South)</label>
            <CurrencyInput
              placeholder="Price"
              name="Price"
              v-model="price"
              :distraction-free="distractionFree"
              class="disabled"
              disabled
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Sequence Number</label>
            <input
              type="text"
              name="SequenceNumber"
              placeholder="Sequence Number"
              v-model="sequence"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                class
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{button}} Part</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "PartDetails",
  components: {},
  data() {
    return {
      hideNegligibleFractionDigits: false,
      hideCurrencySymbol: false,
      hideThousandsSeparatorSymbol: false,
      showModal: false,
      code: "",
      codes: [],
      item: "",
      quantityPerMachine: 0,
      description: "",
      price: null,
      sequence: 0,
      machines: [],
      machineId: "",
      assemblies: [],
      assemblyId: "",
      subAssemblies: [],
      subAssemblyId: "",
      active: true,
      error: "",
      disabled: false,
      button: "",
      title: ""
    };
  },
  computed: {
    distractionFree() {
      return {
        hideNegligibleFractionDigits: this.hideNegligibleFractionDigits,
        hideCurrencySymbol: this.hideCurrencySymbol,
        hideThousandsSeparatorSymbol: this.hideThousandsSeparatorSymbol,
      };
    },
  },
  mounted() {
    $(".ui.dropdown").dropdown({fullTextSearch: true, sortSelect: true, match: "text"});
    if (this.$route.params.id == undefined) {
      this.disabled = false;
      this.getMachineSelectedItems();
      $(".ui.dropdown .remove.icon").on("click", function(e) {
        $(this)
          .parent(".dropdown")
          .dropdown("clear");
        e.stopPropagation();
      });
      this.button = 'Add';
      this.title = 'Add';
    } else {
      this.disabled = true;
      this.partDetails();
      this.button = 'Save';
      this.title = 'Edit';

      //this.getMachineSelectedItems();
    }
  },
  methods: {
    onMachineChange(event) {
      this.machineId = event.target.value;
      this.assemblies = [];
      this.assemblyId = "";
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.getAssemblyList();
    },
    onAssemblyChange(event) {
      this.assemblyId = event.target.value;
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.getSubAssemblySelectedItems();
    },
    onSubAssemblyChange(event) {
      this.subAssemblyId = event.target.value;
      this.code = "";
      this.codes = [];
      this.getCodeSelectedItems();
    },
    onCodeChange(event) {
      this.price = event.explicitOriginalTarget?.dataset?.price || 0;
      this.price = parseFloat(this.price);
      this.code = event.target.value;
    },
    getAssemblyList() {
      apiService.getAssemblyList({ id: this.machineId,  showAll: true }).then((data) => {
        this.assemblies = data;

       if(this.assemblyId != null) {
          let _this = this;
          setTimeout(function() {
            $("#AssemblySelect").dropdown("set selected", _this.assemblyId);
          }, 2000);
        }
        $(".ui.dropdown").dropdown({fullTextSearch: true, sortSelect: true, match: "text"});
      });
    },
    getMachineSelectedItems() {
      apiService.getMachinesList().then((data) => {
        this.machines = data;

        if(this.machineId != null) {
          let _this = this;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", _this.machineId);
          }, 2000);
        }
        $(".ui.dropdown").dropdown({fullTextSearch: true, sortSelect: true, match: "text"});
      });
    },
    getSubAssemblySelectedItems() {
      apiService.getSubAssemblyList({ id: this.assemblyId }).then((data) => {
        this.subAssemblies = data;

        if(this.subAssemblyId != null) {
          let _this = this;
          setTimeout(function() {
            $("#SubAssemblySelect").dropdown("set selected", _this.subAssemblyId);
          }, 2000);
        }
        $(".ui.dropdown").dropdown({fullTextSearch: true, sortSelect: true, match: "text"});
      });
    },
    getCodeSelectedItems() {
      apiService.getCodeList().then((data) => {
        this.codes = data;

        if(this.code != null) {
          let _this = this;
          setTimeout(function() {
            $("#CodeSelect").dropdown("set selected", _this.code);
          }, 2000);
        }
        $(".ui.dropdown").dropdown({fullTextSearch: true, sortSelect: true, match: "text"});
      });
    },
    partDetails() {
      apiService
        .getPartDetails({ id: this.$route.params.id })
        .then((request) => {
          this.partSuccessful(request);
          // console.log(this.machineId);
          let _this = this;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", _this.machineId);
            $("#AssemblySelect").dropdown("set selected", _this.assemblyId);
            $("#SubAssemblySelect").dropdown(
              "set selected",
              _this.subAssemblyId
            );
            
            $("#CodeSelect").dropdown("set selected", _this.code);

            $(".ui.dropdown .remove.icon").on("click", function(e) {
              $(this)
                .parent(".dropdown")
                .dropdown("clear");
              e.stopPropagation();
            });
          }, 2000);

          this.getMachineSelectedItems();
          this.getAssemblyList();
          this.getSubAssemblySelectedItems();
          this.getCodeSelectedItems();
        })
        .catch((err) => this.partFailed(err));
    },
    partSuccessful(request) {
      (this.item = request.item),
      (this.code = request.code),
      (this.description = request.description),
      (this.quantityPerMachine = request.quantityPerMachine),
      (this.price = request.price),
      (this.sortOrder = request.sortOrder),
      (this.sequence = request.sequence),
      (this.machineId = request.assembly.machineId),
      (this.assemblyId = request.assembly.parentAssemblyId),
      (this.subAssemblyId = request.assemblyId),
      (this.active = request.active);
    },
    partFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    partUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createPart({
            Item: this.item,
            Code: this.code,
            Description: this.description,
            QuantityPerMachine: this.quantityPerMachine,
            Price: this.price,
            SortOrder: this.sortOrder,
            Sequence: this.sequence,
            AssemblyId: this.subAssemblyId,
            Active: this.active
          })
          .then(() => {
            this.$router.push("/admin/parts");
          })
          .catch((err) => this.partFailed(err));
      } else {
        apiService
          .updatePart({
            id: this.$route.params.id,
            Item: this.item,
            Code: this.code,
            Description: this.description,
            QuantityPerMachine: this.quantityPerMachine,
            Price: this.price,
            Sequence: this.sequence,
            SortOrder: this.sortOrder,
            machineId: this.machineId,
            assemblyId: this.subAssemblyId,
            Active: this.active,
          })
          .then(() => {
            this.$router.push("/admin/parts");
          })
          .catch((err) => this.partFailed(err));
      }
    },
  },
};
</script>
